import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { RoundedIcon, NavBar } from '@warrenbrasil/nebraska-web';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  group: string;
  position?: string;
  width?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    group: null,
    position: { default: 'top center' },
    width: { default: '100%' }
  },
  setup(__props: any) {

const props = __props as { group: string, position: string, width: string };



function getColors(type: NotificationTypes) {
  switch (type) {
    case NotificationTypes.error:
      return {
        color: NebraskaColors.statusNegative,
        background: NebraskaColors.statusNegativeBackground
      };
    case NotificationTypes.success:
      return {
        color: NebraskaColors.statusPositive,
        background: NebraskaColors.statusPositiveBackground
      };
    case NotificationTypes.info:
      return {
        color: NebraskaColors.statusInfo,
        background: NebraskaColors.statusInfoBackground
      };
    case NotificationTypes.alert:
      return {
        color: NebraskaColors.statusAlert,
        background: NebraskaColors.statusAlertBackground
      };
    case NotificationTypes.primary:
    default:
      return {
        color: NebraskaColors.textNegative,
        background: NebraskaColors.neutralPrimary
      };
  }
}

function getTextColor(type: NotificationTypes) {
  return getColors(type).color;
}

function getBackgroundColor(type: NotificationTypes) {
  return getColors(type).background;
}

return { __sfc: true,props, getColors, getTextColor, getBackgroundColor, NebraskaColors, RoundedIcon, NavBar }
}

})